import React from "react";
import { Adresse } from "../../interfaces";

interface AdressesTablePorops {
  adresses: Adresse[];
  onRemoveAdresse: (index: number) => void;
}

const AdressesTable = ({ adresses, onRemoveAdresse }: AdressesTablePorops) => {
  return (
    <table className="w-full text-sm border border-gray-400 text-left text-gray-500 ">
      <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
        <tr>
          <th scope="col" className="px-6 py-3">
            Nom
          </th>
          <th scope="col" className="px-6 py-3">
            rue
          </th>
          <th scope="col" className="px-6 py-3">
            rue 2
          </th>
          <th scope="col" className="px-6 py-3">
            Code postal
          </th>
          <th scope="col" className="px-6 py-3">
            ville
          </th>
          <th scope="col" className="px-6 py-3">
            pays
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {adresses.length !== 0
          ? adresses?.map((adresse, index) => {
              return (
                <tr key={index} className="bg-white border-b ">
                  <td className="px-6 py-4">{adresse.nom_adresse}</td>
                  <td className="px-6 py-4">{adresse.rue}</td>
                  <td className="px-6 py-4">{adresse.rue2}</td>
                  <td className="px-6 py-4">{adresse.code_postal}</td>
                  <td className="px-6 py-4">{adresse.ville}</td>
                  <td className="px-6 py-4">{adresse.pays}</td>
                  <td>
                    <button
                      onClick={() => onRemoveAdresse(index)}
                      className="inline-flex items-center  bg-white-600 hover:bg-white-700 text-black text-sm font-medium rounded-md"
                    >
                      x
                    </button>
                  </td>
                </tr>
              );
            })
          : null}
      </tbody>
    </table>
  );
};

export default AdressesTable;
